import React from "react";

import {
  Dialog,
  DialogContent,
  DialogHeading,
  DialogClose,
  IconButton,
  Button,
} from "components/LibraryComponents/Components";
import { Icon } from "@trussworks/react-uswds";

import styles from "./ClaimBusiness.module.scss";

type ClaimedDialogProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ClaimedDialog(props: ClaimedDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.setOpen}>
      <DialogContent className={styles["claimed-dialog-root"]} hasBackdrop>
        <div className={styles["claimed-dialog-body"]}>
          <div className={styles["header"]}>
            <DialogHeading className={styles["heading"]}>
              Businesses using this TIN have already been claimed
            </DialogHeading>

            <IconButton
              type="button"
              Icon={<Icon.Close aria-hidden="true" />}
              size="sm"
              onClick={() => props.setOpen(false)}
              tabIndex={-1}
              aria-label="Close dialog"
            />
          </div>
          <div className={styles["claimed-content"]}>
            <ul>
              <li>
                If you claimed the business from another account, please log in to
                that account.
              </li>
              <li>
                If your business has other qualifying owners, please ensure that
                they have not already claimed the business. Each business can
                only be claimed once.
              </li>
              <li>
                If none of the above are true, contact our support team for
                assistance at{" "}
                <a href="https://www.sba.gov/" rel="noreferrer" target="_blank">
                  search@sba.gov
                </a>
                .
              </li>
            </ul>
          </div>
        </div>

        <div className={styles["claimed-dialog-footer"]}>
          <Button
            type="submit"
            className={styles["btn-close"]}
            aria-label="Export results to CSV"
            onClick={() => props.setOpen(false)}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
